var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocument28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24 3H5v23h19V3ZM6 25V4h17v21H6ZM20 9H9v1h11V9ZM9 14h11v1H9v-1Zm5 5H9v1h5v-1Z",
  clipRule: "evenodd"
})));
export { SvgDocument28 as ReactComponent };
export default __webpack_public_path__ + "34dd894f3b89b3c0005520675ab92d9e.svg";